import { render } from "./MusicTrackResult.vue?vue&type=template&id=25196052"
import script from "./MusicTrackResult.vue?vue&type=script&lang=js"
export * from "./MusicTrackResult.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__